export const AUTHENTICATE = "AUTHENTICATE";
export const LOGOUT = "LOGOUT";
export const ADDINTEREST = "ADDINTEREST";
export const SETINTERESTS = "SETINTERESTS";
export const SETNAVIGATE = "SETNAVIGATE";
export const LOADINGHOME = "LOADINGHOME";
